import { Trans } from "@coworker/locales";
import { FC } from "react";
import styled from "styled-components";
import { FixaSkeleton } from "../../shared/wrappers/FixaSkeleton/FixaSkeleton";

const TotalCountContainer = styled.div`
  padding: 16px;
  margin: 8px;
  background-color: var(--grey100);
  border-radius: 8px;
`;

const TotalCountTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 8px;
`;

const TotalCountText = styled.p`
  font-size: 1.5rem;
`;

const TotalCount: FC<{ title: string; count: string; isLoading: boolean }> = ({
  title,
  count,
  isLoading,
}) => {
  return (
    <TotalCountContainer>
      <TotalCountTitle>
        <Trans>{title}String</Trans>
      </TotalCountTitle>
      {isLoading ? (
        <FixaSkeleton height="32.5px" width="100%" />
      ) : (
        <TotalCountText>{count}</TotalCountText>
      )}
    </TotalCountContainer>
  );
};

export default TotalCount;
